import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=ad7c039c&"
import script from "./HowToPlay.vue?vue&type=script&lang=ts&"
export * from "./HowToPlay.vue?vue&type=script&lang=ts&"
import style0 from "./HowToPlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports